import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../queries';
import { handleError } from '../../../../components/ui/err/handleError';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../types';
import { IGetAiAgentCompanyListParams, IGetAiAgentServiceOperationSettingsHistoryParams } from './types';

export function useGetAiAgentCompanies(param: IGetAiAgentCompanyListParams) {
  return useQuery({
    ...queries.aiAgent.aiAgentCompanies(param),
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}

export function useGetAiAgentServiceOperationSettings(companyId: number) {
  return useQuery({
    ...queries.aiAgent.serviceOperationSettings(companyId),
    enabled: !!companyId,
    select: (data) => data.result[0],
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}

export function useGetAiAgentServiceOperationSettingsHistory(params: IGetAiAgentServiceOperationSettingsHistoryParams) {
  return useQuery({
    ...queries.aiAgent.serviceOperationSettingsHistory(params),
    enabled: params.companyId > 0,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
